module.exports = __webpack_public_path__ + "img/RWA.72a7d7a8.svg";